import template from "./library-tariffs-page.html";

const LibraryTariffsPageComponent = {
  bindings: {},
  template: template,
  controller: class LibraryTariffsPageController {
    /* @ngInject */
    constructor($filter, Tariff, $rootScope, SweetAlertService, Notification) {
      this.$filter = $filter;
      this.Tariff = Tariff;
      this.$rootScope = $rootScope;
      this.SweetAlertService = SweetAlertService;
      this.NotificationService = Notification;
    }

    async $onInit() {
      this.tariffs = [];
      this.tariffsCount = 0;
      this.searchOptions = {
        description: "",
        page: 1,
      };
      this.editMode = null;
      this.newTariffFormOpened = false;
      this.loading = false;

      await this.refreshTariffsAndCount();
      this.$rootScope.$applyAsync();

      this.$rootScope.$watch(
        () => this.searchOptions.description,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal)) {
            this.searchOptions.description = newVal;
            this.refreshTariffsAndCount().then();
          }
        },
      );
    }

    openEditForm(tariffId) {
      this.editMode = tariffId;
    }

    closeEditForm() {
      this.editMode = null;
    }

    openNewTariffForm() {
      this.newTariff = new this.Tariff();
      this.newTariffFormOpened = true;
    }

    closeNewTariffForm() {
      this.newTariffFormOpened = false;
    }

    async onTariffSaved() {
      this.newTariffFormOpened = false;
      this.closeEditForm();
      await this.refreshTariffsAndCount();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")("notificationService.message.tariffSaved"),
      });
    }

    async deleteTariff(tariff) {
      if (await this.SweetAlertService.wantRemoveTariff()) {
        await tariff.delete();
        await this.refreshTariffsAndCount();
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.deleteTariff"),
        });
      }
    }

    async loadTariffsCount() {
      this.tariffsCount = await this.Tariff.getCount({
        q: this.searchOptions.description,
      });
      this.$rootScope.$applyAsync();
    }

    async refreshTariffs() {
      this.tariffs = await this.loadTariffs();
      this._resetPagination();
      this.$rootScope.$applyAsync();
    }

    async loadTariffs() {
      const tariffs = await this.Tariff.query({
        q: this.searchOptions.description || "",
        page: this.searchOptions.page,
      });
      return tariffs;
    }

    async loadMoreTariffs() {
      const loadedTariffs = this.tariffs.length;
      const tariffsToLoad = this.tariffsCount;
      if (loadedTariffs < tariffsToLoad && !this.loading) {
        this.searchOptions.page++;
        const tariffs = await this.loadTariffs();
        this.tariffs = this.tariffs.concat(tariffs);
        this.$rootScope.$applyAsync();
      }
    }

    refreshTariffsAndCount() {
      return Promise.all([this.loadTariffsCount(), this.refreshTariffs()]);
    }

    _resetPagination() {
      this.searchOptions.page = 1;
    }
  },
};

export default LibraryTariffsPageComponent;
